<template>
  <div>
    <template v-if="readOnly">
      <div v-if="!modelValue?.isValid" class="verdi error-message">
        {{ modelValue?.errorMessage }}
      </div>
      <div v-else-if="modelValue?.text && modelValue?.isValid" :class="{ 'single-line': singleLine }"
           class="verdi">
        {{ modelValue?.text }}
      </div>
      <div v-else class="verdi muted">
        (blank)
      </div>
    </template>
    <template v-else>
      <BaseSelect
        :isClearable="header.isNullable"
        :model-value="modelValue?.value"
        :options="valueListItems"
        @change="changed"
      />
      <BaseProgressBar v-if="saving" class="progress-bar" />
    </template>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import BaseSelect from '@/components/BaseComponents/BaseSelect.vue'
import BaseProgressBar from '@/components/BaseComponents/BaseProgressBar.vue'
import { useVerdilisteStore } from '@/store/storeVerdiliste'
import { useTableStore } from '@/store/storeTable'

const verdilisteStore = useVerdilisteStore();

const props = defineProps({
  modelValue: {
    type: Object,
    default: null
  },
  readOnly: {
    type: Boolean,
    default: false
  },
  singleLine: {
    type: Boolean,
    default: false
  },
  autoSave: {
    type: Boolean,
    default: true
  },
  rowId: { type: [String, Number], default: '' },
  header: { type: Object, required: true }
});

const valueListItems = ref([]);

watch(() => [props.rowId, props.header.listOfValueObjectId], ([, listOfValueObjectId]) => {
  const result = verdilisteStore.getVerdiListe(listOfValueObjectId);
  // getVerdiListe kan returnere false eller undefined hvis verdilisten ikke er lastet
  // BaseSelect forventer alltid en array
  valueListItems.value = Array.isArray(result) ? result : [];
}, { immediate: true });

// TableStore
const tableStore = useTableStore()

const saving = ref(false)

const emit = defineEmits(['update:modelValue'])

function changed (newValue) {
  if (newValue === "IcsNullValue_") {
    newValue = null;
  }

  const updatedColumnData = {
    ...props.modelValue,
    value: newValue
  };

  emit('update:modelValue', updatedColumnData);
  if (!props.autoSave) return;

  const item = { rowId: props.rowId, databaseObjectId: props.header.databaseObjectId, columnName: props.header.field, oldValue: props.modelValue, newValue: newValue };
  saving.value = true
  tableStore.saveData(item);
  saving.value = false;
}
</script>

<style scoped>
.verdi {
  min-height: 1.2rem;
  padding: 8px;
}
/* Style the select box */
select {
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 3px;
  background-color: #fff;
  font-size: 16px;
  color: #333;
  appearance: none;
  cursor: pointer;
  /* Add padding for the icon */
  padding: 8px 30px 8px 12px;
}

/* Ensure proper padding in options */
select option {
  padding: 8px 12px;
  font-size: 16px;
  line-height: 1.5rem;
  color: #333;
  background-color: #fff;
  border-bottom: 1px solid #ddd;
  border-radius: 0;
}

/* Remove bottom border for last option */
select option:last-child {
  border-bottom: none;
}

/* Style the selected option */
select option:checked {
  background-color: #e5f1fb;
  color: #333;
}

/* Style the hover and focus state of the select box */
select:hover,
select:focus {
  border-color: #007bff;
  outline: none;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

/* Style the hover state of the options */
select option:hover {
  background-color: #f1f1f1;
}

/* Style the focus state of the options */
select option:focus {
  background-color: #e5f1fb;
}
</style>
